import { Select } from '@web/components/atoms/Select'
import { CustomFieldComponentProps } from '../CustomFieldComponent'

const SingleSelect = ({
  id,
  name,
  label,
  acceptedValues,
  onChange,
  value,
  defaultValue,
  isRequired,
}: CustomFieldComponentProps) => {
  return (
    <Select
      id={`custom-field-${name}`}
      name={name}
      fieldProps={{ label, required: isRequired }}
      onChange={(e) => {
        onChange?.({
          target: {
            name: id,
            value: e.target.value,
          },
        } as React.ChangeEvent<HTMLSelectElement>)
      }}
      value={value ?? ''}
      color="ge.text.primary"
      bgColor="white"
    >
      {!defaultValue && <option value="">Select...</option>}
      {(acceptedValues || []).map((v) => {
        return (
          <option key={v.key} value={v.value}>
            {v.value}
          </option>
        )
      })}
    </Select>
  )
}

export default SingleSelect
